import React from 'react'
import { HeadlineStyle, HeadlineProps, HeadlineTag } from './Headline.types'

export const defaultStyle: HeadlineStyle = {
  colorScheme: {
    primary: 'color-scheme-primary',
    secondary: 'color-scheme-secondary'
  },
  textPosition: {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }
}

const Headline = ({
  children,
  tag = 'h1',
  uppercase = false,
  colorScheme = 'primary',
  textPosition = 'left',
  className = ''
}: HeadlineProps) => {
  const HeadingWithTag = tag as HeadlineTag
  const cssClasses: string[] = [
    `headline-${tag}`,
    defaultStyle.colorScheme[colorScheme],
    defaultStyle.textPosition[textPosition],
    className
  ]

  if (uppercase) {
    cssClasses.push('headline--uppercase')
  }

  return (
    <HeadingWithTag className={cssClasses.join(' ')}>{children}</HeadingWithTag>
  )
}

export default Headline
